import { render, staticRenderFns } from "./PageCategoriesUpdate.vue?vue&type=template&id=5546645c&scoped=true&"
import script from "./PageCategoriesUpdate.vue?vue&type=script&lang=ts&"
export * from "./PageCategoriesUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./PageCategoriesUpdate.vue?vue&type=style&index=0&id=5546645c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5546645c",
  null
  
)

export default component.exports